export default {
    serverURI: '',
    fixedLayout: false,
    hideLogoOnMobile: false,
    fpsVersion: process.env.FPS_VERSION || 'v1/',
    fpsApiUpload: process.env.FPS_UPLOAD || 'upload',
    fpsAuth: process.env.FPS_AUTH || 'YWlydGFibGU6bnV3YTg4ODg=',
    adminAuthUserEditUrl: process.env.ADMIN_AUTH_USER_EDIT_URL || '/admin/user/edit',
    adminAuthUserAdminUrl: process.env.ADMIN_AUTH_USER_ADMIN_URL || '/admin/user/admin',
    adminAuthResetUrl: process.env.ADMIN_AUTH_RESET_URL || '/admin/reset',
    adminAuthForgetPwdUrl: process.env.ADMIN_AUTH_FORGET_PWD_URL || '/admin/forgetpwd/',

    developerApiVersion: process.env.DEVELOPER_API_VERSION || 'v1/',
    developerApiPrefix: process.env.DEVELOPER_API_PREFIX || 'developer/',
    developerAdminPrefix: process.env.DEVELOPER_ADMIN_PREFIX || 'admin/',
    developerUserPrefix: process.env.DEVELOPER_USER_PREFIX || 'user/',
    developerApiLoginPrefix: process.env.DEVELOPER_API_LOGIN_PREFIX || 'login/',
    developerApiLoginInfo: process.env.DEVELOPER_API_LOGININFO || 'info',
    developerApiVerify: process.env.DEVELOPER_API_VERFIY || 'verify',
    developerApiUser: process.env.DEVELOPER_API_USER || 'user',
    developerApiApp: process.env.DEVELOPER_API_USER || 'app',
    developerApiFile: process.env.DEVELOPER_API_FILE || 'list/',
    developerApiDownload: process.env.DEVELOPER_API_DOWNLOAD || 'download/',
    developerApiRegister: process.env.DEVELOPER_API_REGISTER || 'register',
    developerApiComplete: process.env.DEVELOPER_API_COMPLETE || 'complete',
    developerApiTicket: process.env.DEVELOPER_API_TICKET || 'ticket/',
    developerApiMail: process.env.DEVELOPER_API_MAIL || 'mail/',
    developerApiMessage: process.env.DEVELOPER_API_MESSAGE || 'message/',
    developerApiMotionFile: process.env.DEVELOPER_API_MOTIONFILE || 'motionFile/',
    developerApiUpload: process.env.DEVELOPER_API_UPLOAD || 'upload',
    developerApiMotionCategory: process.env.DEVELOPER_API_MOTION_CATEGORY || 'motionCategory',
    developerApiMotionTag: process.env.DEVELOPER_API_MOTION_TAG || 'motionTag',

    storeApiVersion: process.env.STORE_API_VERSION || 'v1/',
    storeApiPrefix: process.env.STORE_API_PREFIX || 'miboStoreAdmin/',
    storeApiLogin: process.env.STORE_API_LOGIN || 'login',
    storeApiContent: process.env.STORE_API_CONTENT || 'contents',
    storeApiDecorations: process.env.STORE_API_DECORATIONS || 'decorations',
    storeApiGoods: process.env.STORE_API_GOODS || 'goods',
    storeApiBundle: process.env.STORE_API_BUNDLE || 'bundle',
    storeApiRecommend: process.env.STORE_API_RECOMMEND || 'recommend',
    storeApiFeedback: process.env.STORE_API_FEEDBACK || 'feedback',
    storeApiCategory: process.env.STORE_API_CATEGORY || 'category',
    storeApiChannel: process.env.STORE_API_CHANNEL || 'channel',
    storeApiTag: process.env.STORE_API_TAG || 'tag',
    storeApiMarket: process.env.STORE_API_MARKET || 'market',
    storeApiHot: process.env.STORE_API_HOT || 'hot',
    storeApiReport: process.env.STORE_API_REPORT || 'report',
    storeApiOrder: process.env.STORE_API_ORDER || 'order',
    storeApiContentStatus: process.env.STORE_API_CONTENT_STATUS || 'status',
    storeApiContentResource: process.env.STORE_API_CONTENT_RESOURCE || 'resource',
    storeApiTemp: process.env.STORE_API_TEMP || 'temp',
    storeApiDownload: process.env.STORE_API_DOWNLOAD || 'download',
    storeApiMiboNews: process.env.STORE_API_MIBO_NEWS || 'miboNews',
    storeApiPet: process.env.STORE_API_MIBO_PET || 'miboPet',
    storeApiPetVersion: process.env.STORE_API_MIBO_PET_VERSION || 'dataVersion',
    defaultLangCode: process.env.DEFAULT_LANG_CODE || 'zh-CN',
    defaultAdminMailDomain: process.env.DEFAULT_ADMIN_MAIL_DOMAIN || 'nuwarobotics.com',
    env: {
        localhost: {
            adminApiDomain: 'http://uat-api.nuwarobotics.com',
            developerApiDomain: 'http://uat-api.nuwarobotics.com/',
            // adminApiDomain: 'http://localhost:5100',
            // developerApiDomain: 'http://localhost:6700/'
            localhostDomain: 'http://localhost:8070',
            localhostDomainApi: 'http://localhost:8080/developerUser/'
        },
        'dev-dss': {
            adminApiDomain: 'http://dev-api.nuwarobotics.com',
            adminAuthLoginDomain: 'http://dev-nuwa-account.nuwarobotics.com',
            adminAuthLoginPort: '80',
            fpsDomain: 'http://dev-file.nuwarobotics.com',
            fpsPort: '80',
            storeApiDomain: 'http://dev-api.nuwarobotics.com/',
            adminAuthLoginUrl: '/admin/login?redirect_url=http://dev-mibo.nuwarobotics.com/developerAdmin/dashboard',
            developerApiDomain: 'http://dev-api.nuwarobotics.com/',
            localhostDomain: 'http://localhost:8070',
            localhostDomainApi: 'http://localhost:8080/developerUser/'
        },
        'uat-dss': {
            adminApiDomain: 'http://uat-api.nuwarobotics.com',
            adminAuthLoginDomain: 'http://uat-nuwa-account.nuwarobotics.com',
            adminAuthLoginPort: '80',
            fpsDomain: 'http://uat-file.nuwarobotics.com',
            fpsPort: '80',
            storeApiDomain: 'http://uat-api.nuwarobotics.com/',
            adminAuthLoginUrl: '/admin/login?redirect_url=http://uat-mibo.nuwarobotics.com/developerAdmin/dashboard',
            developerApiDomain: 'http://uat-api.nuwarobotics.com/'
        },
        'stg-dss': {
            adminApiDomain: 'http://stg-api.nuwarobotics.cn',
            adminAuthLoginUrl: '/admin/login?redirect_url=https://stg-mibo.nuwarobotics.cn/developerAdmin/dashboard',
            developerApiDomain: 'https://stg-api.nuwarobotics.cn/',
            localhostDomain: 'http://localhost:8070',
            localhostDomainApi: 'http://localhost:8080/developerUser/'
        },
        dss: {
            adminApiDomain: 'http://api.nuwarobotics.cn',
            adminAuthLoginDomain: 'http://nuwa-account.nuwarobotics.cn',
            adminAuthLoginPort: '80',
            fpsDomain: 'http://file.nuwarobotics.cn',
            fpsPort: '80',
            storeApiDomain: 'http://api.nuwarobotics.cn/',
            adminAuthLoginUrl: '/admin/login?redirect_url=http://mibo.nuwarobotics.con/developerAdmin/dashboard',
            developerApiDomain: 'https://api.nuwarobotics.cn/',
            localhostDomain: 'http://localhost:8070',
            localhostDomainApi: 'http://localhost:8080/developerUser/'
        }
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js